module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"categories":"Categories:"}}')
  delete Component.options._Ctor
}
